// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__YYNR0","footer_menu":"Footer_footer_menu__PIMwh","footer_profile":"Footer_footer_profile__3jp56","footer_copyright":"Footer_footer_copyright__50hVU"};